export const ATLASSIAN_JIRA_ISSUE_URL = 'https://jira.collaboration-man.com/browse';
export const ATLASSIAN_JIRA_ISSUE_LABEL = 'CreatedByMdmOtaFe';

export function getSummaryKey(serialNumber) {
    return `${serialNumber} (OTA):`
}
